var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column m-3",attrs:{"data-cy":_vm.dataCy}},[(_vm.shouldShowWebUploader)?_c('study-web-upload',_vm._b({attrs:{"with-integrity-check":""},on:{"uploaded-attachments":function($event){return _vm.$emit('uploaded-attachments', $event)},"uploaded":function($event){return _vm.$emit('uploaded', $event)}}},'study-web-upload',{
      fileValidator: _vm.fileValidator,
      isDicomOnly: _vm.isDicomOnly,
      convertAttachments: _vm.convertAttachments,
      anonymize: _vm.anonymize,
      singlePatient: _vm.singlePatient,
      anonymizeSettings: _vm.anonymizeSettings,
      generateRequiredMissingTags: _vm.generateRequiredMissingTags,
      append: _vm.append,
      dataCy: _vm.dataCy,
    },false)):_vm._e(),_vm._v(" "),_c('research-upload-area-data-organism',_vm._b({attrs:{"segmentation":_vm.showSegmentationInstance},on:{"segmentation":function($event){return _vm.$emit('segmentation', $event)}}},'research-upload-area-data-organism',{
      instanceId: _vm.instanceId,
      repositoryUuid: _vm.repositoryUuid,
      readonly: _vm.readonly,
      moduleUuid: _vm.moduleUuid,
      moduleSettings: _vm.moduleSettings,
      module: _vm.module,
      isFromSegmentationModule: _vm.isFromSegmentationModule,
      showSegmentationInstance: _vm.showSegmentationInstance,
      segmentationOptions: _vm.segmentationOptions,
      reviewButtonText: _vm.reviewButtonText,
      repository: _vm.repository,
      project: _vm.project,
      subject: _vm.subject,
      event: _vm.event,
    },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }